import '@expo/metro-runtime';
import React, { useEffect } from 'react';
import { withInitEnv } from 'src/hoc/withInitEnv';
import { ChatProvider } from 'src/_shared/chat/ChatProvider';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { detectIncognito } from 'src/_shared/utils/detect-incognito/detectIncognito';
import { neutrals, text } from 'src/theme/colors';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { TooltipProvider } from '@photosi/rn-components/tooltips/tooltip-provider/TooltipProvider';
import { AppNavigator } from 'src/routes/_shared/routes';
import { logWarning } from 'src/_shared/logger';
import { LayoutDimensionsProvider } from 'src/providers/LayoutDimensionsProvider';

const App = observer(() => {
  const {
    i18n,
    toastStore: { showInfoToast },
  } = useStore();
  const { isMobile } = useResponsiveScreen();

  useEffect(() => {
    detectIncognito()
      .then(({ isPrivate }) => {
        if (isPrivate) {
          showInfoToast({
            message: i18n.t('toast:incognito-hint'),
            ctaText: i18n.t('toast:accept-and-close'),
            iconColor: isMobile ? neutrals.white : text.secondaryText,
            id: 'toast-incognito-hint',
            removeOnPress: true,
            onPress: () => {},
            icon: ICON_NAMES.Incognito,
          });
        }
      })
      .catch(e => {
        logWarning(e);
      });
  }, []);

  return (
    <LayoutDimensionsProvider>
      <TooltipProvider>
        <ChatProvider>
          <AppNavigator />
        </ChatProvider>
      </TooltipProvider>
    </LayoutDimensionsProvider>
  );
});

export default withInitEnv(App);
